// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lkO3","comment":"styles_comment__yopFy"};